import { FC } from "react";
import BlogPost from "../models/blogPost"
import { Card, CardActionArea, CardContent, CardMedia, Link, Stack, Typography } from "@mui/material";
import { getPublicBlogPostHeroImageUrl } from "../utils/fileUtils";
import { formatDate } from "../utils/formatUtils";

type Props = {
	blogPost: BlogPost;
};

const BlogTile: FC<Props> = ({ blogPost }) => {
	return (
		<Card>
			<CardActionArea sx={{ display: 'flex', alignItems: 'normal' }}>
				<CardMedia
					sx={{
						flex: '0 0 200px'
					}}
					image={getPublicBlogPostHeroImageUrl(blogPost)}
					title={blogPost.title}
				/>
				<CardContent
					component="a"
					href={`blog/${blogPost.slug}`}
					sx={{ flex: '1 1 auto' }}
				>
					<Stack spacing={1} sx={{ width: '100%' }}>
						<Stack direction="row" spacing={2} justifyContent="space-between" alignItems="flex-start">
							<Typography variant="h5" color="textPrimary">
								{blogPost.title}
							</Typography>
							<Typography variant="body2" color="textSecondary">
								{blogPost.publishDate ? formatDate(blogPost.publishDate, 'dddd, MMMM D, YYYY') : ''}
							</Typography>
						</Stack>
						<Stack spacing={3}>
							<Typography variant="body2" color="textSecondary">
								{blogPost.abstract}
							</Typography>
							<Link sx={{ textTransform: 'uppercase' }} href={`blog/${blogPost.slug}`}>Read more...</Link>
						</Stack>
					</Stack>
				</CardContent>
			</CardActionArea>
		</Card>
	)
};

export default BlogTile;
